// extracted by mini-css-extract-plugin
export default {"document":"styles_document__S40u-","label":"styles_label__LqUW2","last":"styles_last__xX93I","button":"styles_button__VW-XT"};